// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MfaScreen-ContentCardContent{min-height:180px;margin-top:8px;margin-bottom:12px;align-items:center;justify-content:center;flex-direction:column;display:flex}.MfaScreen-empty-card{position:relative;height:180px}", ""]);
// Exports
module.exports = exports;
